module.exports = __webpack_public_path__ + "static/media/photo7-3.0e325862.webp";